export default {
    header: {
        title: 'Courses by Coursera',

        categories: 'Categories:',
        viewAllInCategory: 'View all {name}',
        browseCatalog: 'Browse Catalog',
        myCourses: 'My Courses',
        howTo: 'How to',
        howItWorks: 'How it works',

        search: {
            placeholder: 'Search for courses...',
            noResults: 'No results',
        },
    },
    body: {
        recommendedByHighered: 'Recommended by Highered',
        intro: {
            header: 'Become the preferred candidate with Highered Upskill powered by Coursera',
            text:
                'For only 49 Euros you will get direct access to unique custom skills curations based on the needs of the companies looking for talent today.  The 49€ include unlimited courses and certifications for one month, certifications you should have on your CV or LinkedIn profile to stand out from the crowd.',
            p1:
                'Build important in-demand skills that will set you apart from the competition in the application process. Take courses from top employers to become the preferred candidate.',
            p2:
                'Showcase your new abilities with unlimited certificates for Guided Projects and Professional Certificates.',
            p3:
                'Start using Highered Upskill today and increase your chances to land that dream job early.',
        },
    },
    courseModal: {
        about: {
            enroll: 'Enroll',
            getStarted: 'Get started',
            getAccess: 'Get access',
            startsAt: 'Starts {date}',

            nRatings: '{n} ratings',
            nReviews: '{n} reviews',
            sponsored: 'Sponsored by Highered',
            offeredBy: 'Offered by',

            approxDuration: 'Approx. {hours} hours to complete',
            difficultyLevel: {
                beginner: 'Beginner',
                intermediate: 'Intermediate',
                advanced: 'Advanced',
            },

            aboutCourse: 'About this course',
        },
        instructors: {
            instructors: 'Instructors',
        },
    },
    subscriptions: {
        join: {
            h1: 'Be employable today!',
            h2: 'Choose the right plan and start learning with Coursera',

            oneMonthAccess: '1-month access',
            sixMonthAccess: '6-month access',
            specialAccess: 'Special access',

            bestValue: 'Best value',
            choose: 'Choose',

            subscription: 'Subscription',
            oneTimePurchase: 'One-time purchase',

            amountCourses: '5,200+ courses',
            amountGuidedProjects: '250+ Guided Projects',
            certificatesIncluded: 'Certificates included',
            cencelAnytime: 'Cancel anytime',
            percentOff: '20% off AON Assessments',

            disclaimer: 'Features are subject to code validation',
            insertCode: 'Insert code',
            whereToFindCode: 'Where to find the code?',
        },
        howTo: {
            accessGranted: 'Access granted!',
            purchaseSuccessful: 'Purchase successful!',

            howToProceed: 'How to proceed',
            paragraph:
                'You now have access to a huge catalog of Courses and Guided Projects on Coursera. Follow the steps below to get started.',
            goToCoursera: 'Go to Coursera',

            steps: {
                p1: 'Click the button below (will open a new tab)',
                p2: 'Log in with your Highered credentials',
                p3: 'It may take a minute or two before your account is connected to the program',
                p4: 'Start learning!',
            },
        },
    },
};
